export type WebhookEventSubscriptionEventType = ValueOf<
  typeof WEBHOOK_EVENT_SUBSCRIPTION_EVENT_TYPE
>;
export const WEBHOOK_EVENT_SUBSCRIPTION_EVENT_TYPE = {
  APPLICANT_STATUS_CHANGE: 'APPLICANT_STATUS_CHANGE',
} as const;

export type WebhookEventSubscriptionEventTriggerType = ValueOf<
  typeof WEBHOOK_EVENT_SUBSCRIPTION_EVENT_TRIGGER_TYPE
>;
export const WEBHOOK_EVENT_SUBSCRIPTION_EVENT_TRIGGER_TYPE = {
  ACCEPTED: 'ACCEPTED',
  PHONE_INTERVIEWING: 'PHONE_INTERVIEWING',
  INTERVIEWING: 'INTERVIEWING',
  VALIDATING: 'VALIDATING',
  EMPLOYED: 'EMPLOYED',
} as const;

export type WebhookEventSubscriptionSubscriberType = ValueOf<
  typeof WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE
>;
export const WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE = {
  INOVA: 'INOVA',
  TEAM_ENGINE_GENERIC: 'TEAM_ENGINE_GENERIC',
} as const;

export const subscriberTypeDisplayName = (
  subscriberType: WebhookEventSubscriptionSubscriberType,
) => {
  switch (subscriberType) {
    case WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE.INOVA:
      return 'Inova';
    default:
      return 'Webhook';
  }
};

// These types are duplicated in the server and applicant-updated-event-handler in serverless, if updating these be sure to update there as well
export type InovaCreateRecordType = ValueOf<typeof INOVA_CREATE_RECORD_TYPE>;
export const INOVA_CREATE_RECORD_TYPE = {
  APPLICANT: 'applicant',
  EMPLOYEE: 'employee',
} as const;
